<template>
  <div id="login" :style="{backgroundImage:bgimg}">
    <header class="headerIcon" v-show="ifInternal">
      <img src="../../assets/img/login/logo_page.png" alt />
    </header>
    <header class="headerIcon2" v-show="ifGree">
      <img src="../../assets/img/login/logo_page_gree.png" alt />
      <div class='headerFont'>
        格力网销管理系统
      </div>
    </header>
    <header class="headerIcon" v-show="ifExternal">
      <img src="../../assets/img/login/logo_Upage.png" alt />
    </header>
    <div class="content_center" :style="{ height: activeHeight + 'px' }">
      <div style="margin: 0 auto">
        <section class="loginBox" :style="{ height: activeHeight + 'px' }">
          <div class="titleName">
            <span v-show="ifLoginPwd">
              <span v-show="ifInternal || ifGree">密码登录</span>
              <span v-show="ifExternal">内部人员登录</span>
            </span>
            <span v-show="!ifLoginPwd">扫码登录</span>
          </div>
          <!--提示-->
          <div class="hintContainer">
            <div v-if="locShow" style="text-align: center;">
              <el-link :href="locNhref" type="primary" target="_blank" style="margin-right: 20px;">
                内部
              </el-link>
              <el-link :href="locWhref" type="primary" target="_blank">
                外部
              </el-link>
            </div>
          </div>
          <el-form ref="form" :model="form" class="loginForm" v-show="ifLoginPwd">
            <el-form-item>
              <div class="loginIcon">
                <img src="../../assets/img/login/login_acc2.png" alt v-show="focuesIcon.focusUser" />
                <img
                  src="../../assets/img/login/login_acc_right.png"
                  alt
                  v-show="!focuesIcon.focusUser"
                />
              </div>
              <el-input
                placeholder="用户名"
                v-model="form.username"
                @keyup.enter.native="verity"
                @focus="focuesIcon.focusUser=!focuesIcon.focusUser"
                @blur="focuesIcon.focusUser=!focuesIcon.focusUser"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="loginIcon">
                <img src="../../assets/img/login/login_pwd.png" alt v-show="focuesIcon.password" />
                <img
                  src="../../assets/img/login/login_pwd_right.png"
                  alt
                  v-show="!focuesIcon.password"
                />
              </div>
              <el-input
                placeholder="密码"
                v-model="form.password"
                type="password"
                @keyup.enter.native="verity"
                @focus="focuesIcon.password=false"
                @blur="focuesIcon.password=true"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 10px;float: left" v-show="ifInternal || ifGree">
              <div class="loginIcon">
                <img src="../../assets/img/login/login_code.png" alt v-show="focuesIcon.code" />
                <img
                  src="../../assets/img/login/login_code_right.png"
                  alt
                  v-show="!focuesIcon.code"
                />
              </div>
              <el-input
                placeholder="验证码"
                v-model="form.code"
                style="width: 240px;"
                @keyup.enter.native="verity"
                @focus="focuesIcon.code=!focuesIcon.code"
                @blur="focuesIcon.code=!focuesIcon.code"
              ></el-input>
              <img :src="form.codeget" alt class="yzm" />
              <!-- <span @click="getCodeimg">换一张</span> -->
              <i class="el-icon-refresh-right" @click="getCodeimg" style="cursor: pointer;color: #1681d9;font-size: 18px;"></i>
            </el-form-item>
            <!-- <el-form-item style="clear: both" v-show="ifExternal"> -->
              <div class="forgetPwd" v-show="ifExternal" style="clear: both;margin-bottom: 30px;">
                <el-checkbox v-model="form.checked">记住密码</el-checkbox>
                <span @click="forgetPwd" v-show="ifInternal || ifGree">忘记密码</span>
              </div>
            <!-- </el-form-item> -->
            <el-form-item class="forgetContainer" style="clear: both" v-show="!ifExternal">
              <div class="forgetPwd" v-show="!ifExternal">
                <el-checkbox v-model="form.checked">记住密码</el-checkbox>
                <span @click="forgetPwd" v-show="ifInternal || ifGree">忘记密码</span>
              </div>
            </el-form-item>
            <el-form-item style="margin-bottom:10px">
              <el-button class="btnConfire" @click="verity" :loading="loginLoad">登录</el-button>
            </el-form-item>
            <el-form-item style="margin-top: 25px;" v-show="ifInternal || ifGree">
              <span class="wechatLogin2" style="margin-right: 73px;">第三方扫码登录</span>
              <img src="../../assets/img/login/form_wechat.png" alt class="wechat" @click="checkout(1)"/>
              <span class="wechatLogin" @click="checkout(1)" style="margin-right: 25px;">微信</span>
              <img src="../../assets/img/login/form_dingding.png" alt class="wechat" style="width: 44px;height: 44px;" @click="checkout(2)"/>
              <span class="wechatLogin" @click="checkout(2)">钉钉</span>

            </el-form-item>
          </el-form>
          <div v-show="!ifLoginPwd" class="qrContainer" style="height: 279px;">
            <iframe class="ifrm" :src="wxUrl"></iframe>
          </div>
          <div v-show="!ifLoginPwd" class="qrContainer">
            <div class="tsQr">请使用微信扫二维码登录</div>
            <div class="goPwd" @click="ifLoginPwd=true" style="color:#108cee">使用账号密码登录</div>
          </div>
        </section>
      </div>
    </div>
    <div class="footerJS2">Copyright© 2019 杭州久点网络技术有限公司</div>
  </div>
</template>

<script>
import aes from "../../libs/aes";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "login",
  data: function() {
    return {
      locNhref: '',
      locWhref: '',
      locShow: false,
      canLogin: true,
      focuesIcon: {
        focusUser: true,
        password: true,
        code: true
      },
      hint: false,
      ifLoginPwd: true,
      form: {
        username: "",
        code: "",
        password: "",
        usertype: "",
        checked: false,
        msg: "",
        codeget: "/hcm/code"
      },
      wxUrl: "",
      bgimg: "",
      backgroundImage:
        "url(" + require("../../assets/img/login/login_bg_gree.png") + ")",
      backgroundImage_gree:
        "url(" + require("../../assets/img/login/login_bg.png") + ")",
      backgroundImage_Ugree:
        "url(" + require("../../assets/img/login/login_Ubg.png") + ")",
      ifGree: false,
      ifInternal: false,
      ifExternal: false,
      loginLoad: false,
      activeHeight: 425,
    };
  },
  mounted() {
    //新上线后开启↓
    let url = window.location.href;
    let wechatLogin;
    if (url.indexOf("console") != -1 || url.indexOf("/login/u") != -1) {
      console.log("内部版");
      localStorage.setItem("usertype", "u"); //内部
      this.form.usertype = "u";
      wechatLogin = "brm_u";

      this.ifExternal = true;
      this.bgimg = this.backgroundImage_Ugree; //内部背景图
      this.activeHeight = 425;
    } else if (url.indexOf("gree") != -1) {
      console.log("格力版");
      wechatLogin = "gree";

      this.ifGree = true;
      this.bgimg = this.backgroundImage; //格力背景图
      this.activeHeight = 496;
    } else {
      console.log("外部版");
      localStorage.setItem("usertype", "c"); //外部
      this.form.usertype = "c";
      wechatLogin = "brm_c";

      this.ifInternal = true;
      this.bgimg = this.backgroundImage_gree; //外部背景图
      this.activeHeight = 496;
    }
    //新上线后开启↑

    //测试环境
    if (
      url.indexOf("192.168") != -1 ||
      url.indexOf("localhost") != -1 ||
      url.indexOf("wxtest.olonger.com") != -1 ||
      url.indexOf("139.9.160.67") != -1 ||
      url.indexOf("brm.qmwp.top") != -1
    ) {
      const path = this.$route.path;
      let a = path.charAt(path.length - 1);
      this.form.usertype = a;

      // 只有本地和测试环境才可以使用
      if (url.indexOf("/login/u") != -1) {
        console.log("内部版");
        this.locNhref = url
        this.locWhref = url.slice(0, -2)
      } else {
        this.locNhref = url + '/u'
        this.locWhref = url
      }

      this.locShow = true
    }
    console.log(this.form.usertype);
  },
  created() {
    let username = localStorage.getItem("username");
    let password = localStorage.getItem("password");
    let checked = localStorage.getItem("checked");
    if (username) this.form.username = username;
    if (password) this.form.password = password;
    if (checked == "true") this.form.checked = true;
    this.getCodeimg(); //获取验证码
    this.qrconnect();
    this.selecthcmloginlogo();
    //断开websocket
    if (sessionStorage.getItem("stateLine") === "1") {
      this.socketClose();
    }
  },
  computed: {
    ...mapGetters(["menuLogo"])
  },
  methods: {
    locFun(e) {
      if (e == 1) {
        console.log(window.location.href)
      } else {

      }
    },
    ...mapActions(["selecthcmloginlogo"]),
    ...mapMutations(["socketClose"]),
    qrconnect() {
      localStorage.setItem('logiNType','no');
      //微信扫码登录
      var redirect_uri = encodeURIComponent(
        window.location.origin + "/#/wechatLogin"
         // "http://wxtest.olonger.com/#/wechatLogin"
      );
      let appid =
        window.location.host === "gree.olonger.com"
          ? "wx8ea259e36a53d9cb"
          : "wx5a234db344041ccf";
      // let appid ='wx99f6a3c4b2a2e2f4';//238的
      this.wxUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_login&state=${redirect_uri}`;
      console.log(this.wxUrl)
      console.log(redirect_uri)
    },
    forgetPwd() {
      const path = this.$route.path;
      let a = path.charAt(path.length - 1);
      this.$router.replace({ name: "findpwd" });
    },
    verity() {
      if (this.form.username == "") {
        // this.form.msg = "请填写用户名";
        this.$message.error('请填写用户名');
        this.hint = true;
        return false;
      }
      if (this.form.password == "") {
        // this.form.msg = "请填写密码";
        this.$message.error('请填写密码');
        this.hint = true;
        return false;
      }
      if (!this.ifExternal) {
        if (this.form.code == "") {
          // this.form.msg = "请填写验证码";
          this.$message.error('请填写验证码');
          this.hint = true;
          return false;
        }
      }

      this.pwdlogin();
    },
    pwdlogin() {
      let _this = this;
      if (!this.canLogin) {
        console.log('---')
        return false;
      }
        this.form.msg = "";
      this.hint = false;
      this.loginLoad = true;
      this.canLogin = false;
      let url = window.location.href.substr(0, window.location.href.length - 8);
      let data = {
        // code: this.form.code,
        username: this.form.username.replace(/\s/g, ""),
        password: aes.encrypt(this.form.password, "hcmabcdefghijklm"), //后面的参数是后台的秘钥
        usertype: this.form.usertype,
        url: url.slice(8)
        //'usertype':'u',
      };
      data
      if (this.ifExternal) {
        data.nocode = 'nocode'
      } else {
        data.code = this.form.code
      }
      fetch({
        url: "hcm/login_login",
        method: "post",
        data: data,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        setTimeout(() => {
          _this.canLogin = true;//接口两秒内不能重复提交
        }, 2000);
        this.loginLoad = false;
        if (res.status == "10000") {
          localStorage.setItem("userData", JSON.stringify(res.data)); //存储用户信息
          // 品牌名：优先 companyMemoname，无则用 realname（供诊断页自动填入品牌名称）
          // KEFU（客服）登录不自动填入品牌名
          let diagnosisBrand = "";
          if (res.data.logintype !== "KEFU") {
            diagnosisBrand = res.data.companyMemoname || res.data.realname || "";
          }
          if (diagnosisBrand) {
            localStorage.setItem("diagnosisBrand", diagnosisBrand);
          } else {
            localStorage.removeItem("diagnosisBrand");
          }
          localStorage.setItem("username", this.form.username);
          localStorage.setItem("bmcKefuid", res.data.bmcid);
          if (this.form.checked) {
            localStorage.setItem("password", this.form.password);
            localStorage.setItem("checked", this.form.checked);
          } else {
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("checked");
          }
          localStorage.setItem("token", res.data.logintype);
          //测试路由失效问题↓↓
          this.$router.replace({ path: "/homeInterim" });
        } else {
          _this.canLogin = true;
          // this.form.msg = res.message;
          this.$message.error(res.message);
          this.hint = true;
        }
      }).catch(()=>{
          setTimeout(() => {
          _this.canLogin = true;
        }, 2000);
        this.loginLoad = false;
      })
    },
    getCodeimg() {
      var date = Date.parse(new Date());
      this.form.codeget = `${this.form.codeget}?${date}`;
    },
    checkout(e) {
      if (e == 1) {
        this.hint = false;
        this.ifLoginPwd = !this.ifLoginPwd;
      } else {
        this.$message('功能暂未开放');
      }

    },
    ADMINtype(logintype) {
      this.$router.replace({ path: "/adminHomepage" });
    },
    KEFUtype(logintype) {
      this.$router.replace({ path: "/brmHomepage" });
    },
    selectbmcCampaigntype(logintype) {
      fetch({ url: "/hcm/cus/selectbmcCampaigntype", method: "get" }).then(
        res => {
          if (res.status == "10000") {
            if (
              (res.data.campaigntype == null) & (logintype == "HCM") ||
              (res.data.campaigntype == null) & (logintype == "HCMSUB")
            ) {
              this.$router.replace({ path: "/InitialSystem/main" }); //品牌方去系统配置
            } else {
              this.$router.replace({ path: "/BrandHomepage" });
            }
          }
        }
      );
    }
  },
  components: {}
};
</script>
<style lang="scss">
iframe {
  height: 400px;
  overflow: hidden;
  position: absolute;
  z-index: 999;
  top: 44px;
  left: 0;
  width: 100%;
  background: #fff;
  border: none;
}
#login {
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #1681d9 !important;
  }
  .content_center {
    width: 424px;
    position: absolute;
    top: 23%;
    right: 13%;
    z-index: 99999999;
  }
  .headerKF {
    color: #fff;
    font-size: 48px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 50px;
    height: 100px;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #1681d9 !important;
  }
  .el-input__inner {
    padding: 0 40px !important;
    // border-color: #3592de !important;
  }
  .el-checkbox__input .is-checked {
    background: #1681d9 !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #1681d9;
    border-color: #1681d9;
  }
  .el-checkbox__inner:hover,
  .el-checkbox__input .is-focus .el-checkbox__inner,
  .el-checkbox__inner {
    border-color: #1681d9 !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #1681d9;
  }
  .el-button:active {
    border-color: #1681d9 !important;
  }
}
@media screen and (max-width: 1400px) {
  #login .headerKF {
    height: 40px !important;
    margin-bottom: 20px !important;
    font-size: 30px !important;
    margin-top: 10px !important;
  }
}
</style>
<style scoped lang="scss">
#login {
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  // background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position:center;
  .headerIcon {
    height: 96px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    img {
      vertical-align: middle;
      height: 34px;
      cursor: pointer;
      margin-left: 73px;
    }
  }
  .headerIcon2 {
    height: 80px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid white;
    .headerFont {
      font-size: 24px;
      font-weight: 500;
      color: white;
      margin-left: 58px;
      padding-left: 58px;
      border-left: 2px solid #71aafc;
    }
    img {
      vertical-align: middle;
      height: 34px;
      cursor: pointer;
      margin-left: 73px;
    }
  }
  .loginBox {
    position: relative;
    width: 424px;
    // height: 496px;
    background-color: #fff;
    border-radius: 10px;
    margin: auto;
    // box-shadow: 0 3px 2px #ddd;
    .loginImg {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      position: absolute;
      z-index: 1001;
      .titleBox {
        .imgBox {
          display: inline-block;
          width: 75px;
          height: 28px;
          border: 1px solid #bda571;
          background: #faf8f4;
          border-radius: 2px;
          font-size: 12px;
          color: #bda571;
          line-height: 28px;
          text-align: center;
          margin-top: 15px;
        }
        .gore {
          position: relative;
        }

        .gore:before {
          box-sizing: content-box;
          width: 0;
          height: 0;
          position: absolute;
          top: 8px;
          right: -7px;
          padding: 0;
          border-bottom: 4px solid transparent;
          border-top: 4px solid transparent;
          border-left: 4px solid #fff;
          border-right: 4px solid transparent;
          display: block;
          content: "";
          z-index: 12;
        }
        .gore:after {
          box-sizing: content-box;
          width: 0;
          height: 0;
          position: absolute;
          top: 6px;
          right: -11px;
          padding: 0;
          border-bottom: 6px solid transparent;
          border-top: 6px solid transparent;
          border-left: 6px solid #bda571;
          border-right: 6px solid transparent;
          display: block;
          content: "";
          z-index: 10;
        }
      }
      .qrCode {
        margin-left: -4px;
      }
    }
    .titleName {
      text-align: center;
      font-size: 20px;
      color: #333;
      font-weight: 600;
      margin-top: -19px;
      padding-top: 44px;
    }
  }
  .loginForm {
    box-sizing: border-box;
    padding: 0 33px 0 33px;
    .loginIcon {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      width: 40px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 18px;
        height: 21px;
      }
    }
    .el-form-item__content {
      position: relative !important;
    }
    .yzm {
      width: 77px;
      height: 40px;
      vertical-align: middle;
      margin: 0 9px 0 12px;
    }
    span {
      font-size: 12px;
      color: #108cee;
      cursor: pointer;
    }
    .forgetPwd {
      display: flex;
      justify-content: space-between;
    }
    .btnConfire {
      background: #1681d9;
      width: 100%;
      color: #fff;
      font-size: 20px;
      height: 48px;
    }
    .wechat {
      width: 37px;
      height: 37px;
      vertical-align: middle;
      cursor: pointer;
    }
    .wechatLogin {
      color: #666666;
      font-size: 14px;
      margin-left: 8px;
      &:hover {
        color: #108cee;
      }
    }
    .wechatLogin2 {
      color: #666666;
      font-size: 14px;
      margin-left: 8px;
    }
    .forgetContainer {
      margin-top: 0;
      margin-bottom: 10px;
    }
  }
  .hintContainer {
    height: 43px;
    .hint {
      height: 35px;
      border: 1px solid #e55c63;
      background: #ffe6e5;
      font-size: 14px;
      color: #666666;
      line-height: 35px;
      margin: 1px 33px 5px 33px;
      .el-icon-error {
        color: #f5222d;
        font-weight: 500;
        margin: 0 10px;
      }
    }
  }

  .qrContainer {
    text-align: center;
    #wx_qrcode {
      height: 262px;
      img {
        width: 199px;
        height: 179px;
        margin: 37px auto 46px;
      }
    }
    .tsQr {
      font-size: 16px;
      color: #999999;
    }
    .goPwd {
      font-size: 16px;
      color: #333;
      margin-top: 17px;
      cursor: pointer;
    }
  }
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  color: #bda571 !important;
  background: #bda571 !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #666666 !important;
}
.el-form-item {
  margin-bottom: 30px;
}
</style>
